enum SpanPlaceholderSizes {
    ExtraSmall = 'ExtraSmall',
    Smaller = 'Smaller',
    Small = 'Small',
    Medium = 'Medium',
    Large = 'Large',
    Larger = 'Larger',
    ExtraLarge = 'ExtraLarge'
}

enum HeadingPlaceholderVariant {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5'
}

enum GlowingPlaceholderTypes {
    Span = 'Span',
    Paragraph = 'Paragraph',
    Div = 'Div'
}

export {
    SpanPlaceholderSizes,
    HeadingPlaceholderVariant,
    GlowingPlaceholderTypes
};